var map = {
	"./app/i18n/ru.js": 53409,
	"./app/i18n/uz.js": 34195,
	"./entities/alifshop-offer/i18n/ru.js": 53395,
	"./entities/alifshop-offer/i18n/uz.js": 41117,
	"./entities/alifshop-order-item/i18n/ru.js": 96771,
	"./entities/alifshop-order-item/i18n/uz.js": 68941,
	"./entities/alifshop-order/i18n/ru.js": 6229,
	"./entities/alifshop-order/i18n/uz.js": 26599,
	"./entities/application-condition/i18n/ru.js": 9032,
	"./entities/application-condition/i18n/uz.js": 39850,
	"./entities/application-item/i18n/ru.js": 6312,
	"./entities/application-item/i18n/uz.js": 60426,
	"./entities/application/i18n/ru.js": 19224,
	"./entities/application/i18n/uz.js": 7514,
	"./entities/card/i18n/ru.js": 32464,
	"./entities/card/i18n/uz.js": 27394,
	"./entities/cashback/i18n/ru.js": 83214,
	"./entities/cashback/i18n/uz.js": 56776,
	"./entities/category/i18n/ru.js": 42150,
	"./entities/category/i18n/uz.js": 55440,
	"./entities/client-file/i18n/ru.js": 73406,
	"./entities/client-file/i18n/uz.js": 41880,
	"./entities/client-fix-reason/i18n/ru.js": 478,
	"./entities/client-fix-reason/i18n/uz.js": 13432,
	"./entities/client-passport/i18n/ru.js": 20082,
	"./entities/client-passport/i18n/uz.js": 32844,
	"./entities/client-questionnaire/i18n/ru.js": 80197,
	"./entities/client-questionnaire/i18n/uz.js": 39671,
	"./entities/client/i18n/ru.js": 13245,
	"./entities/client/i18n/uz.js": 68223,
	"./entities/comment/i18n/ru.js": 17975,
	"./entities/comment/i18n/uz.js": 28945,
	"./entities/delivery/i18n/ru.js": 11158,
	"./entities/delivery/i18n/uz.js": 21920,
	"./entities/installment/i18n/ru.js": 93301,
	"./entities/installment/i18n/uz.js": 36967,
	"./entities/notification/i18n/ru.js": 95117,
	"./entities/notification/i18n/uz.js": 39727,
	"./entities/offer-demand/i18n/ru.js": 99760,
	"./entities/offer-demand/i18n/uz.js": 75458,
	"./entities/pos-terminal/i18n/ru.js": 74803,
	"./entities/pos-terminal/i18n/uz.js": 85821,
	"./entities/preview-payment/i18n/ru.js": 27265,
	"./entities/preview-payment/i18n/uz.js": 87763,
	"./entities/reject-case/i18n/ru.js": 50808,
	"./entities/reject-case/i18n/uz.js": 39098,
	"./entities/store/i18n/ru.js": 51315,
	"./entities/store/i18n/uz.js": 39037,
	"./entities/warehouse-item/i18n/ru.js": 54123,
	"./entities/warehouse-item/i18n/uz.js": 58789,
	"./features/acquiring-download-excel/i18n/ru.js": 78622,
	"./features/acquiring-download-excel/i18n/uz.js": 61496,
	"./features/acquiring-invoice-create/i18n/ru.js": 54418,
	"./features/acquiring-invoice-create/i18n/uz.js": 18604,
	"./features/add-employee/i18n/ru.js": 73412,
	"./features/add-employee/i18n/uz.js": 10742,
	"./features/add-or-find-new-client/i18n/ru.js": 38736,
	"./features/add-or-find-new-client/i18n/uz.js": 56962,
	"./features/alifshop-order-complete/i18n/ru.js": 92427,
	"./features/alifshop-order-complete/i18n/uz.js": 13445,
	"./features/alifshop-order-create-delivery/i18n/ru.js": 69439,
	"./features/alifshop-order-create-delivery/i18n/uz.js": 28425,
	"./features/alifshop-order-reject/i18n/ru.js": 82871,
	"./features/alifshop-order-reject/i18n/uz.js": 32433,
	"./features/alifshop-order-set-marking/i18n/ru.js": 74390,
	"./features/alifshop-order-set-marking/i18n/uz.js": 60800,
	"./features/application-change-condition/i18n/ru.js": 30335,
	"./features/application-change-condition/i18n/uz.js": 5673,
	"./features/application-change-status-to-delivery/i18n/ru.js": 71741,
	"./features/application-change-status-to-delivery/i18n/uz.js": 75807,
	"./features/application-completion/i18n/ru.js": 17693,
	"./features/application-completion/i18n/uz.js": 72671,
	"./features/application-create/i18n/ru.js": 9183,
	"./features/application-create/i18n/uz.js": 5353,
	"./features/application-edit-first-payment-date/i18n/ru.js": 86082,
	"./features/application-edit-first-payment-date/i18n/uz.js": 98844,
	"./features/application-items-fill-imeis/i18n/ru.js": 56937,
	"./features/application-items-fill-imeis/i18n/uz.js": 31307,
	"./features/application-items-fill-markings/i18n/ru.js": 87284,
	"./features/application-items-fill-markings/i18n/uz.js": 63462,
	"./features/approve-reject-case-refund/i18n/ru.js": 52265,
	"./features/approve-reject-case-refund/i18n/uz.js": 57387,
	"./features/attach-client-card/i18n/ru.js": 58382,
	"./features/attach-client-card/i18n/uz.js": 8776,
	"./features/cancel-acquiring-bml-transaction/i18n/ru.js": 38881,
	"./features/cancel-acquiring-bml-transaction/i18n/uz.js": 99379,
	"./features/cancel-acquiring-transaction/i18n/ru.js": 22267,
	"./features/cancel-acquiring-transaction/i18n/uz.js": 22709,
	"./features/cancel-application-down-payment/i18n/ru.js": 87641,
	"./features/cancel-application-down-payment/i18n/uz.js": 71963,
	"./features/cancel-application-request-approval/i18n/ru.js": 25365,
	"./features/cancel-application-request-approval/i18n/uz.js": 45735,
	"./features/cancel-application/i18n/ru.js": 83663,
	"./features/cancel-application/i18n/uz.js": 46873,
	"./features/card-scoring/i18n/ru.js": 17596,
	"./features/card-scoring/i18n/uz.js": 27294,
	"./features/client-add-card/i18n/ru.js": 3116,
	"./features/client-add-card/i18n/uz.js": 95054,
	"./features/client-send-to-review/i18n/ru.js": 72155,
	"./features/client-send-to-review/i18n/uz.js": 72597,
	"./features/client-update-passport/i18n/ru.js": 13462,
	"./features/client-update-passport/i18n/uz.js": 90592,
	"./features/create-application/i18n/ru.js": 95421,
	"./features/create-application/i18n/uz.js": 99487,
	"./features/create-delivery/i18n/ru.js": 17325,
	"./features/create-delivery/i18n/uz.js": 22799,
	"./features/create-hold-down-payment/i18n/ru.js": 11676,
	"./features/create-hold-down-payment/i18n/uz.js": 84190,
	"./features/create-nasiya-invoice/i18n/ru.js": 34680,
	"./features/create-nasiya-invoice/i18n/uz.js": 33434,
	"./features/create-reject-case/i18n/ru.js": 79877,
	"./features/create-reject-case/i18n/uz.js": 32407,
	"./features/create-reject/i18n/ru.js": 23230,
	"./features/create-reject/i18n/uz.js": 21784,
	"./features/create-warehouse-item/i18n/ru.js": 55904,
	"./features/create-warehouse-item/i18n/uz.js": 15506,
	"./features/employee-change-phone/i18n/ru.js": 21496,
	"./features/employee-change-phone/i18n/uz.js": 3898,
	"./features/employee-edit-info/i18n/ru.js": 80996,
	"./features/employee-edit-info/i18n/uz.js": 18870,
	"./features/employee-toggle-permissions/i18n/ru.js": 49664,
	"./features/employee-toggle-permissions/i18n/uz.js": 67634,
	"./features/engage-application/i18n/ru.js": 79178,
	"./features/engage-application/i18n/uz.js": 4564,
	"./features/login/i18n/ru.js": 16855,
	"./features/login/i18n/uz.js": 32785,
	"./features/offer-demand-create/i18n/ru.js": 21975,
	"./features/offer-demand-create/i18n/uz.js": 21553,
	"./features/offer-demand-edit/i18n/ru.js": 74651,
	"./features/offer-demand-edit/i18n/uz.js": 17621,
	"./features/problem-case-update-status/i18n/ru.js": 63907,
	"./features/problem-case-update-status/i18n/uz.js": 70253,
	"./features/recover-password/i18n/ru.js": 86868,
	"./features/recover-password/i18n/uz.js": 63046,
	"./features/registration/i18n/ru.js": 54083,
	"./features/registration/i18n/uz.js": 9901,
	"./features/reject-reject-case-refund/i18n/ru.js": 83959,
	"./features/reject-reject-case-refund/i18n/uz.js": 33521,
	"./features/request-application-approval/i18n/ru.js": 54856,
	"./features/request-application-approval/i18n/uz.js": 8970,
	"./features/sell-to-alif/i18n/ru.js": 95069,
	"./features/sell-to-alif/i18n/uz.js": 84735,
	"./features/show-bnpl-contract/i18n/ru.js": 65123,
	"./features/show-bnpl-contract/i18n/uz.js": 20941,
	"./features/toggle-lang/i18n/ru.js": 21681,
	"./features/toggle-lang/i18n/uz.js": 69859,
	"./features/toggle-theme/i18n/ru.js": 71782,
	"./features/toggle-theme/i18n/uz.js": 35984,
	"./features/transfer-application-to-another-store/i18n/ru.js": 28970,
	"./features/transfer-application-to-another-store/i18n/uz.js": 30164,
	"./features/update-client-questionnaire/i18n/ru.js": 109,
	"./features/update-client-questionnaire/i18n/uz.js": 44719,
	"./features/upload-application-contract/i18n/ru.js": 71265,
	"./features/upload-application-contract/i18n/uz.js": 68403,
	"./features/upload-client-file/i18n/ru.js": 45346,
	"./features/upload-client-file/i18n/uz.js": 58108,
	"./features/view-real-time-notifications/i18n/ru.js": 88729,
	"./features/view-real-time-notifications/i18n/uz.js": 16232,
	"./features/warehouse-item-toggle-alifshop-offer-visibility/i18n/ru.js": 4079,
	"./features/warehouse-item-toggle-alifshop-offer-visibility/i18n/uz.js": 93465,
	"./features/warehouse-item-update/i18n/ru.js": 72755,
	"./features/warehouse-item-update/i18n/uz.js": 95165,
	"./features/warehouse-items-download/i18n/ru.js": 52579,
	"./features/warehouse-items-download/i18n/uz.js": 1453,
	"./layouts/acquiring/i18n/ru.js": 61977,
	"./layouts/acquiring/i18n/uz.js": 67643,
	"./layouts/admin/i18n/ru.js": 75437,
	"./layouts/admin/i18n/uz.js": 18607,
	"./layouts/alifshop/i18n/ru.js": 64280,
	"./layouts/alifshop/i18n/uz.js": 46682,
	"./layouts/auth/i18n/ru.js": 13056,
	"./layouts/auth/i18n/uz.js": 31026,
	"./layouts/nasiya/i18n/ru.js": 746,
	"./layouts/nasiya/i18n/uz.js": 68031,
	"./layouts/registration/i18n/ru.js": 82379,
	"./layouts/registration/i18n/uz.js": 87045,
	"./pages/acquiring-balances/i18n/ru.js": 87496,
	"./pages/acquiring-balances/i18n/uz.js": 75786,
	"./pages/acquiring-create-invoice/i18n/ru.js": 5531,
	"./pages/acquiring-create-invoice/i18n/uz.js": 48501,
	"./pages/add-new-client/i18n/ru.js": 29859,
	"./pages/add-new-client/i18n/uz.js": 85677,
	"./pages/admin-employee-show/i18n/ru.js": 18973,
	"./pages/admin-employee-show/i18n/uz.js": 65055,
	"./pages/alifshop-offers-show/i18n/ru.js": 66191,
	"./pages/alifshop-offers-show/i18n/uz.js": 29401,
	"./pages/alifshop-order-create-delivery/i18n/ru.js": 44710,
	"./pages/alifshop-order-create-delivery/i18n/uz.js": 58000,
	"./pages/alifshop-orders-show/i18n/ru.js": 96029,
	"./pages/alifshop-orders-show/i18n/uz.js": 95,
	"./pages/alifshop-orders/i18n/ru.js": 91673,
	"./pages/alifshop-orders/i18n/uz.js": 98376,
	"./pages/analytics/i18n/ru.js": 54273,
	"./pages/analytics/i18n/uz.js": 35059,
	"./pages/application-show/i18n/ru.js": 57635,
	"./pages/application-show/i18n/uz.js": 47629,
	"./pages/applications-list/i18n/ru.js": 46875,
	"./pages/applications-list/i18n/uz.js": 83445,
	"./pages/bml-search-clients/i18n/ru.js": 39236,
	"./pages/bml-search-clients/i18n/uz.js": 34038,
	"./pages/bonuses/i18n/ru.js": 73134,
	"./pages/bonuses/i18n/uz.js": 63048,
	"./pages/calculator-preview-payment/i18n/ru.js": 8509,
	"./pages/calculator-preview-payment/i18n/uz.js": 54591,
	"./pages/calculator/i18n/ru.js": 47895,
	"./pages/calculator/i18n/uz.js": 97457,
	"./pages/card-scoring/i18n/ru.js": 79005,
	"./pages/card-scoring/i18n/uz.js": 25087,
	"./pages/client-confirm-agreement/i18n/ru.js": 47784,
	"./pages/client-confirm-agreement/i18n/uz.js": 78602,
	"./pages/clients-list/i18n/ru.js": 71876,
	"./pages/clients-list/i18n/uz.js": 92854,
	"./pages/clients-show/i18n/ru.js": 26889,
	"./pages/clients-show/i18n/uz.js": 39851,
	"./pages/create-application/i18n/ru.js": 95764,
	"./pages/create-application/i18n/uz.js": 71942,
	"./pages/create-delivery/i18n/ru.js": 3938,
	"./pages/create-delivery/i18n/uz.js": 28476,
	"./pages/create-reject-page/i18n/ru.js": 65851,
	"./pages/create-reject-page/i18n/uz.js": 83189,
	"./pages/create-warehouse-item/i18n/ru.js": 63303,
	"./pages/create-warehouse-item/i18n/uz.js": 29729,
	"./pages/deliveries-list/i18n/ru.js": 16550,
	"./pages/deliveries-list/i18n/uz.js": 29840,
	"./pages/deliveries-show/i18n/ru.js": 20515,
	"./pages/deliveries-show/i18n/uz.js": 76333,
	"./pages/employees-list/i18n/ru.js": 28227,
	"./pages/employees-list/i18n/uz.js": 34573,
	"./pages/error-page/i18n/ru.js": 2929,
	"./pages/error-page/i18n/uz.js": 67459,
	"./pages/faq/i18n/ru.js": 84529,
	"./pages/faq/i18n/uz.js": 41603,
	"./pages/home/i18n/ru.js": 86356,
	"./pages/home/i18n/uz.js": 62534,
	"./pages/installment-payment/i18n/ru.js": 43577,
	"./pages/installment-payment/i18n/uz.js": 27899,
	"./pages/knowledge-base-show/i18n/ru.js": 64285,
	"./pages/knowledge-base-show/i18n/uz.js": 19263,
	"./pages/knowledge-base/i18n/ru.js": 20761,
	"./pages/knowledge-base/i18n/uz.js": 9531,
	"./pages/manager-applications-list/i18n/ru.js": 4089,
	"./pages/manager-applications-list/i18n/uz.js": 72059,
	"./pages/nasiya-invoice/i18n/ru.js": 74746,
	"./pages/nasiya-invoice/i18n/uz.js": 60484,
	"./pages/nasiya-search-clients/i18n/ru.js": 75990,
	"./pages/nasiya-search-clients/i18n/uz.js": 76800,
	"./pages/notifications-list/i18n/ru.js": 63636,
	"./pages/notifications-list/i18n/uz.js": 97286,
	"./pages/offer-demands-create/i18n/ru.js": 85309,
	"./pages/offer-demands-create/i18n/uz.js": 58623,
	"./pages/offer-demands-edit/i18n/ru.js": 60777,
	"./pages/offer-demands-edit/i18n/uz.js": 49547,
	"./pages/offer-demands-show/i18n/ru.js": 46400,
	"./pages/offer-demands-show/i18n/uz.js": 41586,
	"./pages/pos-terminals/i18n/ru.js": 64791,
	"./pages/pos-terminals/i18n/uz.js": 92113,
	"./pages/problem-cases-list/i18n/ru.js": 17285,
	"./pages/problem-cases-list/i18n/uz.js": 76759,
	"./pages/registration-complete/i18n/ru.js": 27278,
	"./pages/registration-complete/i18n/uz.js": 840,
	"./pages/reject-case-show/i18n/ru.js": 54587,
	"./pages/reject-case-show/i18n/uz.js": 97557,
	"./pages/reject-cases-list/i18n/ru.js": 76547,
	"./pages/reject-cases-list/i18n/uz.js": 32365,
	"./pages/reports/i18n/ru.js": 22618,
	"./pages/reports/i18n/uz.js": 8356,
	"./pages/sales-list/i18n/ru.js": 14808,
	"./pages/sales-list/i18n/uz.js": 97210,
	"./pages/shipment-offers/i18n/ru.js": 80887,
	"./pages/shipment-offers/i18n/uz.js": 15153,
	"./pages/shipped-offers/i18n/ru.js": 95138,
	"./pages/shipped-offers/i18n/uz.js": 36028,
	"./pages/update-client-passport/i18n/ru.js": 65179,
	"./pages/update-client-passport/i18n/uz.js": 1749,
	"./pages/upload-client-file/i18n/ru.js": 74271,
	"./pages/upload-client-file/i18n/uz.js": 70441,
	"./pages/warehouse/i18n/ru.js": 9814,
	"./pages/warehouse/i18n/uz.js": 10624,
	"./shared/api/i18n/ru.js": 9300,
	"./shared/api/i18n/uz.js": 62182,
	"./shared/hooks/i18n/ru.js": 95696,
	"./shared/hooks/i18n/uz.js": 74274,
	"./shared/i18n/ru.js": 3579,
	"./shared/i18n/uz.js": 40149,
	"./shared/lib/keycloak/i18n/ru.js": 68453,
	"./shared/lib/keycloak/i18n/uz.js": 27927,
	"./shared/lib/vuelidate/i18n/ru.js": 92103,
	"./shared/lib/vuelidate/i18n/uz.js": 58529,
	"./shared/ui/i18n/ru.js": 14730,
	"./shared/ui/i18n/uz.js": 32276,
	"./temp/applications/i18n/ru.js": 90770,
	"./temp/applications/i18n/uz.js": 3532,
	"./temp/invoice/i18n/ru.js": 9732,
	"./temp/invoice/i18n/uz.js": 47606,
	"./temp/otpInfoBlock/i18n/ru.js": 92971,
	"./temp/otpInfoBlock/i18n/uz.js": 19877,
	"./temp/qr-applications/i18n/ru.js": 79138,
	"./temp/qr-applications/i18n/uz.js": 26972,
	"./temp/sidebar/i18n/ru.js": 44923,
	"./temp/sidebar/i18n/uz.js": 87893,
	"./temp/warehouse/i18n/ru.js": 54584,
	"./temp/warehouse/i18n/uz.js": 36986,
	"./widgets/acquiring-balances-list/i18n/ru.js": 28022,
	"./widgets/acquiring-balances-list/i18n/uz.js": 14432,
	"./widgets/alifshop-item-selector-panel/i18n/ru.js": 9451,
	"./widgets/alifshop-item-selector-panel/i18n/uz.js": 36357,
	"./widgets/alifshop-offers/i18n/ru.js": 52410,
	"./widgets/alifshop-offers/i18n/uz.js": 75300,
	"./widgets/alifshop-orders/i18n/ru.js": 75416,
	"./widgets/alifshop-orders/i18n/uz.js": 57818,
	"./widgets/analytics-applications-mean/i18n/ru.js": 2142,
	"./widgets/analytics-applications-mean/i18n/uz.js": 696,
	"./widgets/analytics-applications/i18n/ru.js": 58816,
	"./widgets/analytics-applications/i18n/uz.js": 34770,
	"./widgets/analytics-consultants/i18n/ru.js": 65131,
	"./widgets/analytics-consultants/i18n/uz.js": 75685,
	"./widgets/analytics-demography/i18n/ru.js": 64255,
	"./widgets/analytics-demography/i18n/uz.js": 23241,
	"./widgets/analytics-popular-categories/i18n/ru.js": 29627,
	"./widgets/analytics-popular-categories/i18n/uz.js": 66197,
	"./widgets/analytics-popular-items/i18n/ru.js": 82661,
	"./widgets/analytics-popular-items/i18n/uz.js": 42135,
	"./widgets/analytics-sales-by-date/i18n/ru.js": 58912,
	"./widgets/analytics-sales-by-date/i18n/uz.js": 34866,
	"./widgets/analytics-sales-by-stores/i18n/ru.js": 48342,
	"./widgets/analytics-sales-by-stores/i18n/uz.js": 9120,
	"./widgets/application-completion-flow/i18n/ru.js": 26334,
	"./widgets/application-completion-flow/i18n/uz.js": 11160,
	"./widgets/application-conditions-list/i18n/ru.js": 37070,
	"./widgets/application-conditions-list/i18n/uz.js": 70056,
	"./widgets/applications-list-table/i18n/ru.js": 10955,
	"./widgets/applications-list-table/i18n/uz.js": 37861,
	"./widgets/cancel-application-request-approval-panel/i18n/ru.js": 91392,
	"./widgets/cancel-application-request-approval-panel/i18n/uz.js": 9362,
	"./widgets/card-selection-list/i18n/ru.js": 30528,
	"./widgets/card-selection-list/i18n/uz.js": 6482,
	"./widgets/cashbacks-list/i18n/ru.js": 78660,
	"./widgets/cashbacks-list/i18n/uz.js": 16534,
	"./widgets/client-applications-list/i18n/ru.js": 55844,
	"./widgets/client-applications-list/i18n/uz.js": 13494,
	"./widgets/client-cards-list/i18n/ru.js": 47596,
	"./widgets/client-cards-list/i18n/uz.js": 39534,
	"./widgets/client-common-files-panel/i18n/ru.js": 1738,
	"./widgets/client-common-files-panel/i18n/uz.js": 10772,
	"./widgets/client-file/i18n/ru.js": 68132,
	"./widgets/client-file/i18n/uz.js": 6006,
	"./widgets/deliveries-list-table/i18n/ru.js": 7006,
	"./widgets/deliveries-list-table/i18n/uz.js": 5560,
	"./widgets/employees-table/i18n/ru.js": 89732,
	"./widgets/employees-table/i18n/uz.js": 27606,
	"./widgets/installment-payment/i18n/ru.js": 62992,
	"./widgets/installment-payment/i18n/uz.js": 81218,
	"./widgets/nasiya-search-clients/i18n/ru.js": 96719,
	"./widgets/nasiya-search-clients/i18n/uz.js": 65958,
	"./widgets/offer-demands/i18n/ru.js": 11695,
	"./widgets/offer-demands/i18n/uz.js": 40217,
	"./widgets/problem-case-comment-panel/i18n/ru.js": 27801,
	"./widgets/problem-case-comment-panel/i18n/uz.js": 16571,
	"./widgets/problem-case-info-panel/i18n/ru.js": 89998,
	"./widgets/problem-case-info-panel/i18n/uz.js": 63560,
	"./widgets/problem-cases-list-table/i18n/ru.js": 28695,
	"./widgets/problem-cases-list-table/i18n/uz.js": 39665,
	"./widgets/profile-settings/i18n/ru.js": 41597,
	"./widgets/profile-settings/i18n/uz.js": 96575,
	"./widgets/reports/i18n/ru.js": 21711,
	"./widgets/reports/i18n/uz.js": 84921,
	"./widgets/request-application-approval-panel/i18n/ru.js": 97577,
	"./widgets/request-application-approval-panel/i18n/uz.js": 86347,
	"./widgets/sales-items-list-table/i18n/ru.js": 98693,
	"./widgets/sales-items-list-table/i18n/uz.js": 58167,
	"./widgets/search-clients/i18n/ru.js": 39741,
	"./widgets/search-clients/i18n/uz.js": 43807,
	"./widgets/shipment-offers/i18n/ru.js": 24154,
	"./widgets/shipment-offers/i18n/uz.js": 49540,
	"./widgets/shipped-offers/i18n/ru.js": 59281,
	"./widgets/shipped-offers/i18n/uz.js": 32707,
	"./widgets/warehouse-items/i18n/ru.js": 72350,
	"./widgets/warehouse-items/i18n/uz.js": 71576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86219;